import * as dateFns from 'date-fns';
import * as React from 'react';
const DateText = ({ value, format = 'DD/MM/YYYY', ...rest }) => (React.createElement("span", Object.assign({}, rest), dateFns.format(value, format)));
export default DateText;
//# sourceMappingURL=index.js.map